<h1 mat-dialog-title>TÉRMINOS Y CONDICIONES DE USO</h1>
<mat-dialog-content cdkFocusInitial>
  <p>
    Entre Seguros Vida Security Previsión S.A., en adelante la “Compañía", por
    una parte y por la otra el “Cliente”, debidamente individualizado al final
    de este instrumento, en adelante indistintamente "el Cliente" o "el
    Asegurado" o "el Usuario" o "el Mandante", se celebra el siguiente Convenio
    de Servicios de Seguros a Distancia. PRIMERO: El cliente tiene actualmente
    contratada con la compañía al menos una póliza de seguros de vida con o sin
    ahorro y/o de salud, que se identifica en los sistemas de la compañía con su
    número de Rut que se consigna al final del presente documento, lo que da
    origen a este Convenio de Prestación de Servicios a Distancia. SEGUNDO: Por
    el presente instrumento las partes acuerdan que el Cliente podrá realizar,
    respecto de su(s) Póliza(s) actuales o futuras, las siguientes operaciones
    por vía electrónica: 1. Solicitar información relativa a su(s) Póliza(s),
    tal como beneficiarios, asegurados y fecha de vigencia. 2. Solicitar
    información relativa al estado de pago de las primas. 3. Solicitar
    información relativa a su Valor de Póliza. 4. Solicitar copia de la(s)
    Póliza(s). 5. Solicitar cotizaciones relativas a las modificaciones de la(s)
    Póliza(s) actualmente vigentes, ya sea, por modificación del número de
    personas aseguradas o de las contingencias cubiertas. 6. Solicitar
    modificaciones de la(s) Póliza(s) vigentes o su renovación. 7. Efectuar
    cambio de domicilio. 8. Realizar transferencias entre fondos de inversión o
    entre alternativas de inversión, donde se encuentren invertidas las primas
    pagadas, si se trata de un seguro de vida individual con rentabilidad
    variable. 9. Revisar directamente su cartola de saldo y movimiento y/o
    solicitar su envío. 10. Revisar la gráfica de los valores cuota de los
    fondos mutuos, relacionados al seguro de vida individual con rentabilidad
    variable. 11. Cualquier otra operación que en el futuro implemente la
    Compañía. La sola ejecución por el Cliente de cualquier nueva operación que
    ponga en servicio la Compañía, aún por una sola ocasión, importará
    aceptación del primero de su incorporación al presente contrato, al cual
    quedará sometido y se regirá por sus estipulaciones. TERCERO: El Cliente
    podrá efectuar las operaciones antes indicadas, en la medida que la Compañía
    las tenga implementadas, mediante el uso de alguno de los siguientes medios
    de comunicación: a. Vía telefónica o mail a través del servicio Call Center
    de la Compañía. b. A través del sitio web www.vidasecurity.cl c. Mediante
    otros medios de comunicación que en el futuro implemente la Compañía. En
    todo caso, el sólo uso por el Cliente de estos medios, que ponga en
    funcionamiento la Compañía, aún por una sola ocasión, importará aceptación
    de su incorporación al presente contrato, al cual quedará sometido y se
    regirá por sus estipulaciones. CUARTO: La realización de las operaciones que
    efectúe el Cliente por los medios de comunicación antes señalados, se
    ajustarán a las siguientes condiciones: 1. Las operaciones las efectuará el
    Cliente, proporcionando su número de Rut, seguido del número secreto
    personal registrado en los sistemas computacionales de la Compañía. 2. El
    Cliente, en pleno conocimiento de la normativa vigente sobre seguros y de
    las responsabilidades civiles y penales que pueden derivarse de ella,
    instruye a la Compañía para que acepte y entienda que todo llamado
    telefónico o conexión computacional que efectúe alguna persona dando el
    número secreto además de su número de Rut, se tendrá como hecho por el
    propio cliente. En tal caso, y cumplidos dichos requisitos, la Compañía
    podrá considerar que tal instrucción ha emanado válida, legítima y
    auténticamente del Cliente, sin necesidad de efectuar, realizar, o tomar
    ningún otro resguardo, de ninguna índole, aceptando el Cliente que no deberá
    acreditarse a la Compañía ni a terceros el hecho de la consulta, o el haber
    dado efectivamente la instrucción. Del mismo modo, el Cliente renuncia por
    el presente acto a objetar o negar a la Compañía o a terceros el hecho de
    haberse dado la instrucción telefónica o computacional respectiva, para
    todos los servicios a que se refiere este convenio. Reconoce el Cliente que
    las declaraciones formuladas en este numeral son para la Compañía esenciales
    y han sido condición determinante para que éste celebre el presente
    convenio. 3. Las modalidades utilizadas por la Compañía, para efectos de la
    presentación de servicios a que se refiere el presente convenio, podrán
    efectuarse mediante un sistema automático o vía operadora, según lo disponga
    la Compañía. 4. La información proporcionada por la Compañía bajo las
    señaladas condiciones tendrá carácter de esencialmente provisoria y estará
    sujeta a confirmación en las oficinas de la Compañía. 5. La Compañía podrá
    cobrar comisiones por el servicio de envío de copia de póliza a domicilio o
    por mail, por la mantención y/o uso del servicio Call Center o por servicios
    que en el futuro ponga en funcionamiento, así como también modificar dichas
    comisiones, ambas cosas previo aviso escrito al Cliente entendiéndose
    facultada expresamente la Compañía para efectuar los correspondientes
    cargos.
  </p>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="modal-button">
    <button
      [mat-dialog-close]=""
      mat-stroked-button
      class="button-cerrar"
      (click)="onClose()"
    >
      Cerrar
    </button>
    <button mat-stroked-button class="button-enviar" (click)="firmar()">
      Enviar
    </button>
  </div>
</div>
